import React from 'react';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_CSV_FORMAT_NEW } from 'src/constants/EndpointUrls';
import { REDUCER_NAME } from 'src/reducers/clients/csvFormats';
import { setList } from 'src/reducers/common/listReducer';
import { Plus } from 'jbc-front/components/icons';
import ActionButton from 'jbc-front/components/ActionButton';
import ClientCsvFormatsTable from './components/ClientCsvFormatsTable';
import { useTranslation } from 'react-i18next';

const ClientCsvFormatList = ({ dispatch, clientCsvFormats }) => {
  dispatch(setList(REDUCER_NAME, { data: clientCsvFormats }));
  const { t } = useTranslation();

  return (
    <div className="l-wrap-xl l-contents-wrap">
      <div className="u-mb20">
        <BreadCrumb>
          <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.ClientCsvFormats.ClientCsvFormatList.CSV_format_list')} />
        </BreadCrumb>
      </div>
      <div>
        <h1 className="m-title-main u-mb50">{t('features.ClientCsvFormats.ClientCsvFormatList.CSV_format_list')}</h1>
        <ActionButton as="a" href={CLIENT_CSV_FORMAT_NEW} icon={<Plus size={10} />}>
          {t('features.PayrollRulesGroups.PayrollRulesGroupsList.create_new')}
        </ActionButton>
      </div>
      <ClientCsvFormatsTable />
    </div>
  );
};

export default connect()(ClientCsvFormatList);
